import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  getAllUsersSchedulingListAction,
  getUserAvailabilityReportAction,
  resetAllusersScheduleList,
  resetAllusersScheduleTotalCount,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
  resetUsersAvailabilityReportData,
  resetUsersAvailabilityTotalCount,
} from "../../../../redux/scheduling";
import {
  getFinacInternalUsersAction,
  resetSession,
} from "../../../../redux/auth";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  RadioContainer,
} from "../../../../components/commons";
import { GetUserAvailabilityReportPayloadType } from "../../../../commonTypes/schedulingTypes";
import ReportsDateSelect from "../../../../components/commons/ReportsDateSelect/ReportsDateSelect";
import {
  getCurrentMonthDates,
  handleDate,
  reverseDateFormat,
} from "../../../../utils/commonFunctions";
import AvailabiltyReportCalendarView from "../../../../components/Scheduling/ScheduleReports/AvailabilityReports/AvailabilityReportCalendarView";
import { GetAllFinacUserPayloadType } from "../../../../commonTypes/authTypes";
import useDebounce from "../../../../customHooks/useDebounce";
import { RadioTypes } from "../../../../commonTypes/universalTypes";
import { DropDownType } from "../../../../commonTypes/clientDirectoryTypes";
import AvailabilityReportFilter from "../../../../components/Scheduling/ScheduleReports/AvailabilityReports/AvailabilityReportFilter";
import { DropDownUserType } from "../../../../components/Jobs/RecurringJobReport/RecurringJobReportHeader";
import { GetUsersDepartmentPayloadType } from "../../../../commonTypes/masterDataTypes";
import { getMasterDataUsersDepartmentAction } from "../../../../redux/masterData";
import AvailabilityReportSorting from "../../../../components/Scheduling/ScheduleReports/AvailabilityReports/AvailabilityReportSorting";
import { NextIcon, PrevIcon } from "../../../../components/Icon";

import "../style.scss";
import MultiSelect from "../../../../components/commons/MultiSelect";

type AppProps = {
  token: string | null;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  userFetching: boolean;
  totalAvailableUsersCount: number;
  availableUsersList: any;
  dispatchResetSession: () => void;
  dispatchResetSchedulingError: () => void;
  dispatchResetSchedulingSuccess: () => void;
  dispatchResetSchedulingMessage: () => void;
  dispatchResetSchedulingStatusCode: () => void;
  dispatchResetAvailableUsersTotalCount: () => void;
  dispatchResetAvailableUsersList: () => void;
  dispatchGetFinacInternalUsersAction: (
    data: GetAllFinacUserPayloadType
  ) => void;
  usersList: any;
  userCount: string | number;
  dispatchGetAllAvailableUsersList: (
    data: GetUserAvailabilityReportPayloadType
  ) => void;
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  userDepartmentTotalCount: number;
  userDepartmentList: any;
  usersDepartmentFetching: boolean;
  daysTotal: any;
};

const DAYS_OF_WORK_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "5",
    name: "5 days",
  },
  {
    id: "6",
    name: "6 days",
  },
];

const AvailabilityReport = ({
  token,
  fetching,
  message,
  error,
  statusCode,
  success,
  userFetching,
  totalAvailableUsersCount,
  availableUsersList,
  dispatchResetSession,
  dispatchResetSchedulingError,
  dispatchResetSchedulingSuccess,
  dispatchResetSchedulingMessage,
  dispatchResetSchedulingStatusCode,
  dispatchResetAvailableUsersTotalCount,
  dispatchResetAvailableUsersList,
  dispatchGetFinacInternalUsersAction,
  usersList,
  userCount,
  dispatchGetAllAvailableUsersList,
  dispatchGetMasterDataUsersDepartmentAction,
  userDepartmentTotalCount,
  userDepartmentList,
  usersDepartmentFetching,
  daysTotal,
}: AppProps) => {
  const { start, end } = getCurrentMonthDates();
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [showData, setShowData] = useState(false);
  const [sortByUserName, setSortByUserName] = useState({
    name: "Recently Added First",
    value: "",
  });
  const [toggle, setToggle] = useState<boolean>(false);
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [pendingHours, setPendingHours] = useState(false);
  const [internalUserSelected, setInternalUserSelected] = useState<any>({
    value: null,
    label: "Select...",
  });
  const [activeUser, setActiveUser] = useState<DropDownUserType>({
    value: null,
    label: "Select...",
  });

  const [toggleFilter, setToggleFilter] = useState<boolean>(false);
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [loadCondition, setLoadCondition] = useState(true);
  const [userText, setUserText] = useState<string>("");
  const [userOffset, setUserOffset] = useState<number>(0);
  const [clearUserSearchText, setClearUserSearchText] = useState(false);
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [availabilityLimit, setAvailabilityLimit] = useState(50);
  const [availabilityOffset, setAvailabilityOffset] = useState(0);
  const [daysOfWork, setDaysOfWork] = useState(5);
  const [data, setData] = useState<any>([]);
  // department filter
  const [departmentOffset, setDepartmentOffset] = useState<number>(0);
  const [departmentText, setDepartmentText] = useState<string>("");
  const [finalUsersDepartmentList, setFinalUsersDepartmentList] = useState<any>(
    []
  );
  const [departmentSelected, setDepartmentSelected] = useState<any>({
    value: null,
    label: "Select...",
  });
  const [activeDepartment, setActiveDepartment] = useState<DropDownUserType>({
    value: null,
    label: "Select...",
  });
  // filter badges
  const [multiSelectData, setMultiSelectData] = useState<any>([]);

  useEffect(() => {
    dispatchResetSchedulingError();
    dispatchResetSchedulingSuccess();
    dispatchResetSchedulingMessage();
    dispatchResetSchedulingStatusCode();
    dispatchResetAvailableUsersTotalCount();
    dispatchResetAvailableUsersList();
  }, []);

  useEffect(() => {
    dispatchResetAvailableUsersList();
    if (token && displayStartDate && displayEndDate) {
      let finalData = {
        token,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
        sortByUserName,
        workingDays: daysOfWork,
        departmentId: activeDepartment?.value,
        userId: internalUserSelected?.value,
        offset: availabilityOffset,
        limit: availabilityLimit,
      };
      dispatchGetAllAvailableUsersList(finalData);
    }
  }, [sortByUserName?.name]);

  useEffect(() => {
    if (token) {
      if (userOffset <= +userCount) {
        let finalInternalUserData = {
          token,
          user_type: "stco_users",
          offset: userOffset,
          limit,
          search_term: userText,
        };
        dispatchGetFinacInternalUsersAction(finalInternalUserData);
      }
    }
  }, [userOffset]);

  // internal users list
  useEffect(() => {
    if (usersList?.length > 0) {
      if (userOffset <= +userCount) {
        let finalUserData = usersList?.map((user: any) => {
          return {
            value: user?.user_id,
            label: `${user?.first_name ? user?.first_name : ""} ${
              user?.last_name ? user?.last_name : ""
            } `,
            image: user?.profile_pic?.file_url,
          };
        });
        if (userOffset > 0) {
          setFinalUserList([...finalUserList, ...finalUserData]);
        } else {
          setFinalUserList(finalUserData);
        }
      }
    }
  }, [usersList]);

  // Department List
  useEffect(() => {
    const finalDepartmentListData = userDepartmentList?.map((data: any) => {
      return {
        value: data?._id,
        label: `${data?.department_name}`,
      };
    });
    if (departmentOffset > 0) {
      setFinalUsersDepartmentList([
        ...finalUsersDepartmentList,
        ...finalDepartmentListData,
      ]);
    } else {
      setFinalUsersDepartmentList(finalDepartmentListData);
    }
  }, [userDepartmentList]);

  const fetchInternalNewData = (search: string) => {
    setClearUserSearchText(true);
    const finalData = {
      token,
      offset: userOffset,
      limit,
      user_type: "stco_users",
      search_term: userText,
    };
    if (userOffset === 0) {
      dispatchGetFinacInternalUsersAction(finalData);
    } else {
      setUserOffset(0);
    }
  };

  useDebounce(
    () => {
      if (userText) {
        fetchInternalNewData(userText);
      }
    },
    500,
    [userText]
  );

  useEffect(() => {
    if (token && userDepartmentTotalCount) {
      if (departmentOffset <= +userDepartmentTotalCount) {
        const finalData = {
          token,
          status: 1,
          offset: departmentOffset,
          limit: limit,
          searchValue: departmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    }
  }, [departmentOffset]);

  useEffect(() => {
    if (internalUserSelected?.value || activeDepartment?.value) {
      handleFilter();
      setAvailabilityOffset(0);
      getData();
    }
  }, [internalUserSelected?.value, activeDepartment?.value]);

  useEffect(() => {
    if (clearFilter) {
      handleFilter();
    }
  }, [clearFilter]);

  const handleFilter = () => {
    setShowData(true);
    setAvailabilityOffset(0);
    dispatchResetAvailableUsersList();
    setMultiSelectData([]);
    if (token) {
      let finalData = {
        token,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
        sortByUserName,
        workingDays: daysOfWork,
        departmentId: activeDepartment?.value,
        userId: internalUserSelected?.value,
        offset: 0,
        limit: availabilityLimit,
      };
      dispatchGetAllAvailableUsersList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };

  const fetchUsersDepartmentNewData = () => {
    const finalData = {
      token,
      status: 1,
      offset: departmentOffset,
      limit: limit,
      searchValue: departmentText,
    };
    dispatchGetMasterDataUsersDepartmentAction(finalData);
  };

  useDebounce(
    () => {
      if (departmentText) {
        fetchUsersDepartmentNewData();
      } else {
        const finalData = {
          token,
          status: 1,
          offset: departmentOffset,
          limit: limit,
          searchValue: departmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    },
    500,
    [departmentText]
  );

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleSubmit = () => {
    setShowData(true);
    dispatchResetAvailableUsersList();
    setAvailabilityOffset(0);
    if (token) {
      let finalData = {
        token,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
        sortByUserName,
        workingDays: daysOfWork,
        departmentId: activeDepartment?.value,
        userId: internalUserSelected?.value,
        offset: 0,
        limit: availabilityLimit,
      };
      dispatchGetAllAvailableUsersList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };

  const fetchNewData = (data: number, offset: number) => {
    setShowData(true);
    dispatchResetAvailableUsersList();
    if (token) {
      let finalData = {
        token,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
        sortByUserName,
        workingDays: data,
        departmentId: activeDepartment?.value,
        userId: internalUserSelected?.value,
        offset,
        limit: availabilityLimit,
      };
      dispatchGetAllAvailableUsersList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };

  const checkUserBottom = (e: any) => {
    setLoadCondition(false);
    setUserOffset((prv: any) => prv + limit);
  };

  const checkDepartmentBottom = (e: any) => {
    setLoadCondition(false);
    setDepartmentOffset((prv: any) => prv + limit);
  };

  const checkUsersDepartmentBottom = () => {
    setDepartmentOffset((prv: any) => prv + limit);
  };

  const handleSetWorkStatusRadioValue = (radioValue: string) => {
    setDaysOfWork(+radioValue);
    setAvailabilityOffset(0);
    fetchNewData(+radioValue, 0);
  };

  const fetchAvailabilityData = (listOffset: number) => {
    dispatchResetAvailableUsersList();
    if (token) {
      let finalData = {
        token,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
        sortByUserName,
        workingDays: daysOfWork,
        departmentId: activeDepartment?.value,
        userId: internalUserSelected?.value,
        limit: availabilityLimit,
        offset: listOffset,
      };
      dispatchGetAllAvailableUsersList(finalData);
    }
  };

  const handlePagination = (type: string) => {
    if (type === "next") {
      setAvailabilityOffset((prev) => {
        fetchAvailabilityData(prev + availabilityLimit);
        return prev + availabilityLimit;
      });
    } else {
      setAvailabilityOffset((prev) => {
        fetchAvailabilityData(prev - availabilityLimit);
        return prev - availabilityLimit;
      });
    }
  };

  const getData = useCallback(() => {
    const getSelectedUserValue =
      internalUserSelected?.value != null && internalUserSelected;
    const getDepartmentValue =
      activeDepartment?.value != null && activeDepartment;
    if (getDepartmentValue && getSelectedUserValue) {
      setMultiSelectData([getSelectedUserValue, getDepartmentValue]);
    } else if (getDepartmentValue) {
      setMultiSelectData([getDepartmentValue]);
    } else if (getSelectedUserValue) {
      setMultiSelectData([getSelectedUserValue]);
    } else {
      setMultiSelectData([]);
    }
  }, [activeDepartment, internalUserSelected]);

  const onClose = (id: number | string) => {
    const checkUserValue = id == internalUserSelected?.value;
    const checkDepartmentValue = id == activeDepartment?.value;

    dispatchResetAvailableUsersTotalCount();
    dispatchResetAvailableUsersList();
    if (
      !internalUserSelected?.value ||
      (!activeDepartment?.value && (checkUserValue || checkDepartmentValue))
    ) {
      handleMultiSelectFilter(
        !activeDepartment?.value && checkUserValue
          ? null
          : internalUserSelected?.value,
        !internalUserSelected?.value && checkDepartmentValue
          ? null
          : activeDepartment?.value
      );
    }
    if (checkUserValue) {
      setActiveUser({
        value: null,
        label: "Select..",
      });
      setInternalUserSelected({
        value: null,
        label: "Select...",
      });
      setMultiSelectData([]);
    }
    if (checkDepartmentValue) {
      setActiveDepartment({
        value: null,
        label: "Select...",
      });
      setDepartmentSelected({
        value: null,
        label: "Select...",
      });
      setMultiSelectData([]);
    }
  };
  const handleMultiSelectFilter = (
    userId: null | number,
    departmentId: number | null
  ) => {
    dispatchResetAvailableUsersList();
    dispatchResetAvailableUsersTotalCount();
    if (token) {
      let finalData = {
        token,
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
        sortByUserName,
        workingDays: daysOfWork,
        departmentId,
        userId,
        offset: 0,
        limit: availabilityLimit,
      };
      dispatchGetAllAvailableUsersList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="Availability Report" />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">
                Availability Report
                {!showData ? (
                  <> </>
                ) : (
                  <>
                    {!fetching && (
                      <div className="sub-heading mt-0">{`Total ${
                        totalAvailableUsersCount ? totalAvailableUsersCount : 0
                      } users found`}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="right-heading position-relative d-flex">
              {/* Future Use */}
              {/* <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                                <SearchIcon/>
                            </span>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Search"
                                //   onChange={(e) => handleSearch(e)}
                                style={{ paddingLeft: "45px" }}
                            /> */}
              <div className="ml-2">
                <AvailabilityReportSorting
                  setSortByUserName={setSortByUserName}
                  sortByUserName={sortByUserName}
                  startDate={startDate}
                  endDate={endDate}
                />
              </div>
              {/* added a filter here for future use */}
              <div className="ml-2">
                <AvailabilityReportFilter
                  setClearFilter={setClearFilter}
                  toggle={toggleFilter}
                  setToggle={setToggleFilter}
                  finalUserList={finalUserList}
                  internalUserSelected={internalUserSelected}
                  setInternalUserSelected={setInternalUserSelected}
                  setActiveUser={setActiveUser}
                  activeUser={activeUser}
                  checkUserBottom={checkUserBottom}
                  userFetching={userFetching}
                  setUserText={setUserText}
                  setOffset={setUserOffset}
                  departmentText={departmentText}
                  setDepartmentText={setDepartmentText}
                  setDepartmentOffset={setDepartmentOffset}
                  finalUsersDepartmentList={finalUsersDepartmentList}
                  checkDepartmentBottom={checkDepartmentBottom}
                  usersDepartmentFetching={usersDepartmentFetching}
                  departmentSelected={departmentSelected}
                  setDepartmentSelected={setDepartmentSelected}
                  activeDepartment={activeDepartment}
                  setActiveDepartment={setActiveDepartment}
                  startDate={startDate}
                  endDate={endDate}
                />
              </div>
            </div>
            
          </div>
          {/*  */}
          <div>
            <div className="d-flex align-items-start">
              <div className="form-group ml-3">
                <label className="mb-1">Date</label>
                <div>
                  <ReportsDateSelect
                    setToggle={setToggle}
                    toggle={toggle}
                    startDate={startDate ? startDate : ""}
                    endDate={endDate ? endDate : ""}
                    handleStartDateChange={handleStartDateChange}
                    handleEndDateChange={handleEndDateChange}
                    type={"schedulingReport"}
                  />
                </div>
              </div>
              <div className="ml-3" style={{ marginTop: "29px" }}>
                <button
                  className="btn btn-primary pl-3 pb-2"
                  disabled={!startDate?.length || !endDate?.length || fetching}
                  onClick={handleSubmit}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>

          {!showData ? (
            <div className="mt-5">
              <EmptyListPage
                title="No Availability Report Found!"
                text=""
                imageWidth="30%"
              />
            </div>
          ) : (
            <div>
              {!fetching && startDate?.length && endDate?.length ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    marginBottom: "15px",
                    flexDirection: "row",
                    marginLeft: "20px",
                  }}
                >
                  <span style={{ fontWeight: "500", marginTop: "7px" }}>
                    Days of Work
                  </span>
                  <div className="mt-2 d-flex align-items-center">
                    <RadioContainer
                      optionsList={DAYS_OF_WORK_RADIO_OPTIONS}
                      handleSetRadioValue={handleSetWorkStatusRadioValue}
                      radioValue={daysOfWork?.toString()}
                      alignment="horizontal"
                    />
                  </div>
                </div>
              ) : null}

              <div
                className="header"
                style={{
                  marginTop: "-20px",
                }}
              >
                <div className="left-header note">
                  <span>
                    Note: This report does not include any pending hours.
                  </span>
                </div>
                {totalAvailableUsersCount != 0 && (
                  <div className="right-header mr-2">
                    {availabilityOffset +
                      1 +
                      " - " +
                      (availabilityLimit + availabilityOffset >
                      totalAvailableUsersCount
                        ? totalAvailableUsersCount
                        : availabilityLimit + availabilityOffset) +
                      " of " +
                      totalAvailableUsersCount}
                    <span
                      className="pointer"
                      onClick={() =>
                        availabilityLimit - availabilityOffset != 50
                          ? handlePagination("prev")
                          : null
                      }
                    >
                      <PrevIcon />
                    </span>
                    <span
                      className="pointer"
                      onClick={() =>
                        availabilityOffset + availabilityLimit <
                        totalAvailableUsersCount
                          ? handlePagination("next")
                          : null
                      }
                    >
                      <NextIcon />
                    </span>
                  </div>
                )}
              </div>

              <div className="ml-4">
                <MultiSelect
                 data={multiSelectData} 
                 onClose={onClose}
                 disable={!startDate || !endDate}
              />
              </div>

              <AvailabiltyReportCalendarView
                pendingHours={pendingHours}
                data={availableUsersList}
                fetching={fetching}
                totalCount={totalAvailableUsersCount}
                startDate={startDate}
                endDate={endDate}
                displayStartDate={displayStartDate}
                displayEndDate={displayEndDate}
                daysTotal={daysTotal}
              />
            </div>
          )}
        </div>
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  message: state.scheduling.message,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  success: state.scheduling.success,
  fetching: state.scheduling.fetching,
  userFetching: state.auth.internalFetching,
  usersList: state.auth.internalUsersList,
  userCount: state.auth.internalUserCount,
  availableUsersList: state.scheduling.usersAvailabilityReportData,
  totalAvailableUsersCount: state.scheduling.usersAvailabilityTotalCount,
  userDepartmentTotalCount: state.masterData.userDepartmentTotalCount,
  userDepartmentList: state.masterData.userDepartmentList,
  usersDepartmentFetching: state.masterData.fetching,
  daysTotal: state.scheduling.daysTotal,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSchedulingError: () => dispatch(resetSchedulingError()),
  dispatchResetSchedulingSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetSchedulingMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetSchedulingStatusCode: () =>
    dispatch(resetSchedulingStatusCode()),
  dispatchGetFinacInternalUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getFinacInternalUsersAction(data)),
  dispatchGetAllAvailableUsersList: (
    data: GetUserAvailabilityReportPayloadType
  ) => dispatch(getUserAvailabilityReportAction(data)),
  dispatchResetAvailableUsersList: () =>
    dispatch(resetUsersAvailabilityReportData()),
  dispatchResetAvailableUsersTotalCount: () =>
    dispatch(resetUsersAvailabilityTotalCount()),
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataUsersDepartmentAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityReport);
